<ion-content>
  <section>
    <img
      data-cy="custon-error-page-usf-logo-image"
      src="assets/images/usfoods-logo-color.svg"
      class="usf-logo"
    />
    <h1 data-cy="custom-error-page-title-label">{{ mainErrorMessage }}</h1>
    <p data-cy="custom-error-page-message-text">
      {{ 'i18n.customErrorPage.closeWindow' | translate}}
    </p>
    <p data-cy="custom-error-page-message-text">
      {{ 'i18n.customErrorPage.serviceDesk' | translate}}
    </p>
    <ion-button
      *ngIf="showButton"
      data-cy="custom-error-page-try-again-button"
      class="usf-fill-green-button"
    >
      {{ buttonText }}
    </ion-button>
  </section>
</ion-content>
